import { render, staticRenderFns } from "./global-messenger.vue?vue&type=template&id=5ff9b113&scoped=true&"
import script from "./global-messenger.vue?vue&type=script&lang=js&"
export * from "./global-messenger.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ff9b113",
  null
  
)

export default component.exports